import React from "react";
import { Link } from "react-router-dom";
import "../../styles/NavMenu.scss";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const NavMenu: React.FC<Props> = ({ isOpen, onClose }) => {
  React.useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="mobile-menu-overlay" onClick={onClose}>
      <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
        <ul>
          <li><Link to="/p/profile" onClick={onClose}>View Profile</Link></li>
          {/* <li><Link to="/faqs" onClick={onClose}>FAQs</Link></li> */}
          {/* <li><Link to="/support" onClick={onClose}>Support Centre</Link></li> */}
          <li><Link to="/terms-and-conditions" onClick={onClose}>Terms and Conditions</Link></li>
          {/* <li><Link to="" onClick={onClose}>Terms and Conditions</Link></li> */}
          {/* <li><Link to="/return-refund-policy" onClick={onClose}>Return/Refund Policy</Link></li> */}
          <li><Link to="/privacy-policy" onClick={onClose}>Privacy Policy</Link></li>
          <li><Link to="/end-user-license-agreement" onClick={onClose}>EULA</Link></li>
           {/* <li><Link to="" onClick={onClose}>EULA</Link></li> */}
          {/* <li><Link to="" onClick={onClose}>Privacy Policy</Link></li> */}
        </ul>
      </div>
    </div>
  );
};

export default NavMenu;
